import Link from "next/link";

export default function TargetBlankLink({
  href,
  className,
  children,
  ...props
}) {
  return (
    (<Link
      href={href}
      {...props}
      target="_blank"
      rel="noopener noreferrer"
      className={className}>

      {children}

    </Link>)
  );
}
